export enum UserType {
    Unknown = 0,
    Fleet = 1,
    Vendor = 2,
    Developer = 3
}